<template>
  <div class="card mb-6"
       data-bs-toggle="tooltip"
       data-bs-custom-class="tooltip-inverse"
       data-bs-placement="top"
       data-bs-html="true"
       data-bs-dismiss="hover"
       :title="locale == 'fr' ? module?.description_fr : module?.description_en">
    <div class="p-5 shadow-sm" style="background-color: rgba(0, 114, 206, 0.05); border: 1px solid rgba(0, 114, 206, 0.05); border-radius: 8px;">
      <div class="row px-5">
        <div class="col-3 font-weight-900 fs-2 py-2 px-2 d-flex align-items-center bg-primary justify-content-center" style="border-radius: 8px">
          <img :src="module?.icon"/>
        </div>
        <div class="col-9">
          <h3 class="font-weight-900 mb-3">{{locale == 'fr' ? module?.title_fr : module?.title_en}}</h3>
          <p>{{locale == 'fr' ? module?.description_fr : module?.description_en}}</p>
          <div class="d-flex justify-content-end">
            <div v-if="!module?.enabled">
              <OutlineButton btn-class="btn-sm" btn-text="install" :isDisabled="loading" @click.prevent="installItem(module?.id)" />
            </div>
            <span @click.prevent="installItem(module?.id)" class="text-primary ms-5 fs-3 uninstall-hover" v-else>
              <span class="install"> <i class="fas fa-check-square text-primary mx-2"></i> <span class="text-primary "> {{ $t('installed') }} </span> </span>
              <span class="uninstall" style="display: none"> <i class="fas fa-check-square text-danger mx-2"></i> <span class="text-danger"> {{ $t('uninstalled') }} </span>  </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps } from 'vue'
  import {useLocales} from "@/composables/locales";
  import OutlineButton from "@/components/OutlineButton.vue"

  const emits = defineEmits(['install'])

  const {locale} = useLocales()

  const props = defineProps({
    module: Object,
    app: String,
    loading: {
      type: Boolean,
      default: false
    }
  })

  function installItem(id){
    emits('install', props.app, id)
  }
</script>

<style scoped>
.uninstall-hover {
  cursor: pointer;
}

.uninstall-hover:hover .install{
  display: none!important;
  transition: .5ms;
}

.uninstall-hover:hover .uninstall{
  display: inline-block!important;
  transition: .5ms;
}

</style>
